import { render, staticRenderFns } from "./ActivityLevelModal.vue?vue&type=template&id=45c361b4&scoped=true"
import script from "./ActivityLevelModal.vue?vue&type=script&lang=js"
export * from "./ActivityLevelModal.vue?vue&type=script&lang=js"
import style0 from "./ActivityLevelModal.vue?vue&type=style&index=0&id=45c361b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c361b4",
  null
  
)

export default component.exports